import axios from 'axios';
import getEnv from '@/env-util';
import FileSaver from 'file-saver';
import JSZip from 'jszip';

import { tokenAuthenticator } from '../tokenAuthenticator';

export const DownloadFileFromBinaryStorage = async (binaryFileId) => {
  let result = false;
  try {
    const accessToken = tokenAuthenticator.getToken();
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
      responseType: 'blob',
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    };
    const url =
      getEnv('VUE_APP_BINARY_STORAGE_URL') + '/download-file/' + binaryFileId;
    // Execute request
    const response = await axios.get(url, config);
    //Regex to match filename from header.
    const regex = /filename[^;=\n]*=(?:(['"])(.*?)\1|([^;\n]*))/g;
    const match = regex.exec(response.headers['content-disposition']);

    if (match != null) {
      const filename = match[2] !== undefined ? match[2] : match[3];

      if (filename) {
        const blob = new Blob([response.data]);
        FileSaver.saveAs(blob, filename);
        result = true;
      }
    }
  } catch (error) {
    console.log('Error while downloading file: ', error);
    result = false;
  }

  return result;
};

export const DownloadFile = async (data, mediaFiles, fileName) => {
  try {
    const zip = new JSZip();
    const jsonString = JSON.stringify(data.mediaCollection, null, 2); // 🧹 lesbar formatert
    zip.file(`mediaCollection.json`, jsonString);

    // Legg til blob-filer (eks. bilder)
    mediaFiles.forEach((file) => {
      let mediaFormat = file.jsonData.mediaFormat;
      if (mediaFormat === 'PLAIN' || mediaFormat === 'MARKDOWN') {
        mediaFormat = 'txt';
      }

      const mime = getMimeAndExtension(mediaFormat.toLowerCase());
      const filename = file.id || 'unnamed';

      // Konverter base64 til Blob:
      const blob = base64ToBlob(file.file, mime);
      zip.file(filename + '.dat', blob, { binary: true });

      //Create jsonData connected to file
      const mediaJson = JSON.stringify(file.jsonData, null, 2); // 🧹 lesbar formatert
      zip.file(filename + '.json', mediaJson);
    });

    // Generer zip-filen
    const zipBlob = await zip.generateAsync({ type: 'blob' });
    FileSaver.saveAs(zipBlob, fileName + '.emc');
    return true;
  } catch (error) {
    console.error('Error downloading JSON:', error);
    return false;
  }
};

function base64ToBlob(base64, mimeType) {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: mimeType });
}

// Hjelpefunksjon
function getMimeAndExtension(format) {
  switch (format) {
    case 'png':
      return 'image/png';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'mp3':
      return 'audio/mpeg';
    case 'txt':
      return 'text/plain';
    case 'json':
      return 'application/json';
    default:
      return 'application/octet-stream';
  }
}
